var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.snackbar)?_c('div',[_c('SSnackbar',{attrs:{"message":_vm.message}})],1):_vm._e(),(_vm.toast)?_c('div',[_c('SToast',{attrs:{"time-out":_vm.timeOut,"message":_vm.message,"type":_vm.type}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }